<template>
    <div>
        <profile-user-data />
        <profile-customer-data :customer="customer" />
        <profile-domain-data :customer="customer" />
    </div>
</template>

<script>
import ProfileCustomerData from './ProfileCustomerData.vue';
import ProfileUserData from './ProfileUserData.vue';
import ProfileDomainData from './ProfileDomainData.vue';
import { mapGetters } from 'vuex';
import CustomerApi from '../services/api/customer.js';

export default {
    components: {
        ProfileCustomerData,
        ProfileUserData,
        ProfileDomainData
    },
    computed: {
        ...mapGetters({
            customer: 'customer/firstItem'
        })
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getCustomer();
    },
    methods: {
        /**
         * Get the DNS records.
         */
        getCustomer() {
            CustomerApi.get().then(this.finishLoading);
        }
    }
};
</script>
